/* eslint-disable import/prefer-default-export */
const MINUTE_IN_SECONDS = 60
const HOUR_IN_MINUTES = 60
const DAY_IN_HOURS = 24

export const daysToSeconds = days =>
  days * DAY_IN_HOURS * HOUR_IN_MINUTES * MINUTE_IN_SECONDS
